import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from 'antd';
import pick from 'lodash/pick';
import noop from 'lodash/noop';
import SubmitButton from '../Common/Forms/SubmitButton';
import { signOut } from '../../lib/firebase';
import { toFullName } from '../../lib/users';
import { toLongDateFormat } from '../../lib/dates';
import { clearDownloadLink } from '../../store/ducks/branch';
import { profilePropType, shareableLinkInfoPropType } from '../prop-types';

const { Title, Paragraph, Text } = Typography;

function LoggedInForm({
  currentUserId,
  invitationInfo,
  onSubmit,
  profile,
  removeDownloadLink,
}) {
  const { t } = useTranslation();
  const inviterName = toFullName(invitationInfo.inviterData);
  const { firstName: currentUserName } = profile;

  const onSignOut = useCallback(
    () => signOut().then(removeDownloadLink).catch(noop),
    [removeDownloadLink],
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOnSubmit = useCallback(() => {
    setIsSubmitting(true);
    onSubmit(pick(profile, 'birthday', 'firstName', 'lastName', 'phoneNumber'), true, currentUserId)
      .catch(() => setIsSubmitting(false));
  }, [currentUserId, onSubmit, profile]);

  return (
    <div>
      <Title level={4}>
        <Paragraph>
          {t('answerRequest.withSession.title', { inviterName, currentUserName })}
        </Paragraph>
        <Paragraph>
          <Button onClick={onSignOut}>
            {t('answerRequest.withSession.clearSession', { currentUserName })}
          </Button>
        </Paragraph>
      </Title>

      <Paragraph>
        {t('answerRequest.withSession.shareInformation', { inviterName: invitationInfo.inviterData.firstName })}
      </Paragraph>

      <dl>
        <dt><Text strong>{t('user.name')}:</Text></dt>
        <dd>{toFullName(profile)}</dd>
        <dt><Text strong>{t('user.phoneNumber')}:</Text></dt>
        <dd>{profile.phoneNumber}</dd>
        <dt><Text strong>{t('user.birthday')}:</Text></dt>
        <dd>{toLongDateFormat(profile.birthday)}</dd>
      </dl>

      <SubmitButton onClick={handleOnSubmit} isSubmitting={isSubmitting} block>
        {t('answerRequest.withSession.submit')}
      </SubmitButton>
    </div>
  );
}

LoggedInForm.propTypes = {
  currentUserId: PropTypes.string.isRequired,
  invitationInfo: shareableLinkInfoPropType.isRequired,
  onSubmit: PropTypes.func.isRequired,
  profile: profilePropType.isRequired,
  removeDownloadLink: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  removeDownloadLink: clearDownloadLink,
};

export default connect(null, mapDispatchToProps)(LoggedInForm);
